// site.endeca.result.product = jQuery.extend( true, {}, generic.endeca.result.product, {
//   setupQuickShop: function() {
//   }
// });

(function ($, settings) {
  $(document).on('endeca.search.results.loaded', function (event, data) {
    var productData = data.results.products.resultData || {};
    // Set a context so that we're not targeting the entire page a second time
    var $c = $('.js-end-results');

    // If there are no product results, then show the no-results layer
    if (productData.length == 0) {
      $('.js-end-summary', $c).show();
      var $bestSellerContainer = $('.js-best-sellers-search-result-page-content');
      var $mixItUpContainer = $bestSellerContainer.find('.js-product-grid');

      $bestSellerContainer.removeClass('hidden');
      $mixItUpContainer.mixItUp('destroy', true);
      $mixItUpContainer.mixItUp({
        selectors: {
          target: '.js-product-grid-item--sortable',
          sort: '.js-mpp-sort-option'
        },
        callbacks: {
          onMixEnd: function () {
            // Rebuild equal heights:
            $mixItUpContainer.trigger('grid.reflow');
          }
        }
      });
      $bestSellerContainer.find('.js-product-grid-item').attr('data-bound', '');
      // return;
    } else {
      // Add the product data to the data store
      prodcat.data.updateProducts(productData, false);
    }

    // Initialize the prodcat UI stuff
    if (prodcat.ui && prodcat.ui.init) {
      prodcat.ui.init($c);
    }

    // Now that the product grid JS is in a behavoir, we can just reattach everything with a new context
    Drupal.attachBehaviors($c, settings);

    // Grid equal heights sometime truncating product thumbs
    // Re-init after image load
    var $lastProductImage = $('.js-grid-item .product__image').last();
    var $grid = $('.js-grid');

    $lastProductImage
      .on('load', function () {
        $grid.trigger('grid.reflow');
      })
      .each(function () {
        if (this.complete) {
          $(this).load();
        }
      });

    var gridResize = _.debounce(function () {
      $grid.trigger('grid.reflow');
    }, 300);

    $(window).resize(gridResize);

    if (typeof site.l2Request !== 'undefined') {
      site.l2Request.params = site.l2Request.getParams();
      generic.jsonrpc.fetch(site.l2Request);
    }

    // Initialize some UI stuff for product grids
    // $(window).trigger('load.productGrid');
  });
})(jQuery, Drupal.settings);
